import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

import { useCallback, useEffect, useState } from 'react';
export function useSelectionHelper(selectMode, rowsData, recordAttributeIdentifier, onSelectionChange) {
  var _useState = useState({}),
      selectedRows = _useState[0],
      setSelectedRows = _useState[1];

  var selectedCount = Object.keys(selectedRows).length;
  var columnSelected = rowsData.length && rowsData.every(function (node) {
    return !!selectedRows[node[recordAttributeIdentifier]];
  });
  var clearSelection = useCallback(function () {
    setSelectedRows({});
  }, [setSelectedRows]);
  var toggleRecord = useCallback(function (record, rowSelected) {
    setSelectedRows(function (oldSelectedRows) {
      if (rowSelected) {
        var _extends2;

        return _extends({}, oldSelectedRows, (_extends2 = {}, _extends2[record[recordAttributeIdentifier]] = record, _extends2));
      } else {
        var _record$recordAttribu = record[recordAttributeIdentifier],
            recordToDelete = oldSelectedRows[_record$recordAttribu],
            newSelectedRows = _objectWithoutPropertiesLoose(oldSelectedRows, [_record$recordAttribu].map(_toPropertyKey));

        return newSelectedRows;
      }
    });
  }, [recordAttributeIdentifier]);
  var toggleAllRecordsFromCurrentPage = useCallback(function (checked) {
    setSelectedRows(function (oldSelectedRows) {
      var newSelectedRows = _extends({}, oldSelectedRows);

      rowsData.forEach(function (node) {
        if (checked) {
          newSelectedRows[node[recordAttributeIdentifier]] = node;
        } else {
          delete newSelectedRows[node[recordAttributeIdentifier]];
        }
      });
      return newSelectedRows;
    });
  }, [recordAttributeIdentifier, rowsData]);
  useEffect(function () {
    selectMode && clearSelection();
  }, [selectMode, clearSelection]);
  useEffect(function () {
    return onSelectionChange == null ? void 0 : onSelectionChange(Object.values(selectedRows), selectedCount);
  }, [onSelectionChange, selectedRows, selectedCount, rowsData]);
  return {
    selectedRows: selectedRows,
    columnSelected: columnSelected,
    selectedCount: selectedCount,
    toggleRecord: toggleRecord,
    toggleAllRecordsFromCurrentPage: toggleAllRecordsFromCurrentPage,
    clearSelection: clearSelection
  };
}